type LoadingDotsSize = "normal" | "relaxed";

const sizeStyles = {
  normal: { dot: "h-[3px] w-[3px]", gap: "gap-[2px]" },
  relaxed: { dot: "h-[4px] w-[4px]", gap: "gap-[4px]" },
} satisfies Record<LoadingDotsSize, { dot: string; gap: string }>;

export function LoadingDots({ size = "normal" }: { size?: LoadingDotsSize }) {
  const { dot, gap } = sizeStyles[size];
  return (
    <div className={`loading-dots flex items-center justify-center ${gap}`}>
      <div className={`dot bg-skogecha rounded-full ${dot}`} />
      <div className={`dot bg-skogecha rounded-full ${dot}`} />
      <div className={`dot bg-skogecha rounded-full ${dot}`} />
    </div>
  );
}
export default LoadingDots;
